module.exports = __webpack_public_path__ + "img/dongwuyuan.93250b15.jpg";